<template>
  <div class="position-relative">
    <div class="mt-10 pt-15 px-0 float-left">
      <extra-buttons/>
    </div>

    <!--    <v-tabs v-model="tab" class="mt-5" color="deep-purple accent-4" grow>-->
    <!--      <v-tab v-for="item in TabsName" :key="item.value" @change="getVal(item.value)">{{ item.name }}</v-tab>-->
    <!--    </v-tabs>-->

    <!--    <v-tabs-items v-model="tab">-->
    <!--      <v-tab-item v-for="item in myComponents" :key="item">-->
    <component is="Agency" :de-active="false"/>
    <!--      </v-tab-item>-->
    <!--    </v-tabs-items>-->
  </div>
</template>

<script>
import TitleRibbon from "../../uiBeautifier/titleRibbon";
import ExtraButtons from "../../uiBeautifier/extraButtons";
import Agency from "../singleAds/agency/simpleAds";
import multiAgency from "../singleAds/agency/multiAgency";

export default {
  name: "estates",

  components: {Agency, ExtraButtons, TitleRibbon, multiAgency},

  // data() {
  //   return {
  //     myComponents: [{name: 'Agency', value: 'single'}, {name: 'multiAgency', value: 'multi'},],
  //     TabsName: [{name: 'ارسال تکی', value: 'single'}, {name: 'ارسال گروهی', value: 'multi'}],
  //     tab: '',
  //     activeComponent: 'single'
  //   }
  // },

  // methods: {
  //   getVal(val) {
  //     this.activeComponent = val
  //   }
  // },
}
</script>

<style scoped>

</style>